<template>
  <b-skeleton-wrapper :loading="loading">
    <template #loading>
      <b-row class="parvandeh-role-history">
        <b-col
          cols="12"
          class="parvandeh-role-history__box"
          v-for="(item, index) in items"
          :key="`a-${index}`"
        >
          <div class="parvandeh-role-history__header">
            <div class="parvandeh-role-history__header-right-box w-100">
              <span class="parvandeh-role-history__icon">
                <b-skeleton
                  type="button"
                  width="20px"
                  height="20px"
                ></b-skeleton>
              </span>
              <span class="width-percent-100">
                <b-skeleton width="70%"></b-skeleton>
              </span>
            </div>
            <div class="parvandeh-role-history__header-left-box w-100">
              <span class="parvandeh-role-history__icon">
                <b-skeleton
                  type="button"
                  width="20px"
                  height="20px"
                ></b-skeleton>
              </span>
              <span class="width-percent-100">
                <b-skeleton width="100%"></b-skeleton>
              </span>
            </div>
          </div>
          <div class="parvandeh-role-history__body">
            <div class="parvandeh-role-history__body-right-box w-100">
              <div class="parvandeh-role-history__body-title">
                <b-skeleton width="40%"></b-skeleton>
              </div>
              <div class="parvandeh-role-history__roles">
                <b-skeleton width="70%"></b-skeleton>
              </div>
            </div>
            <div class="parvandeh-role-history__body-left-box w-100">
              <div class="parvandeh-role-history__body-title">
                <b-skeleton width="40%"></b-skeleton>
              </div>
              <div class="parvandeh-role-history__roles">
                <b-skeleton width="100%"></b-skeleton>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </template>
    <slot name="default"></slot>
  </b-skeleton-wrapper>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    count: {
      type: Number,
      default: 6,
    },
  },
  computed: {
    items() {
      const arr = [];
      arr.length = this.count;
      return arr;
    },
  },
};
</script>
